import { render, staticRenderFns } from "./NavSection.vue?vue&type=template&id=55e1ecc2&scoped=true&"
import script from "./NavSection.vue?vue&type=script&lang=js&"
export * from "./NavSection.vue?vue&type=script&lang=js&"
import style0 from "./NavSection.vue?vue&type=style&index=0&id=55e1ecc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e1ecc2",
  null
  
)

/* custom blocks */
import block0 from "./NavSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarTitle } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VAppBarTitle,VBtn,VIcon,VSpacer})
